import React from 'react';
import { Link } from 'react-router-dom';
import { SectionCard } from '../common/SectionCard';
import { campaigns, packageTiers } from '../../data/outreach';
import { formatCompact } from '../../utils/format';
export function OutreachSnapshot() {
  const rows = campaigns.map(campaign => {
    const guarantee = packageTiers.find(tier => tier.id === campaign.tier)?.impressionGuarantee ?? 1;
    return {
      campaign,
      guarantee,
      percent: Math.min(Math.round(campaign.impressions / guarantee * 100), 999)
    };
  });
  const impressions = campaigns.reduce((sum, campaign) => sum + campaign.impressions, 0);
  const engagements = campaigns.reduce((sum, campaign) => sum + campaign.engagements, 0);
  return <SectionCard title="International outreach snapshot" description={`${formatCompact(impressions)} impressions · ${formatCompact(engagements)} engagements across ${campaigns.length} live campaigns`} actions={<Link to="/outreach" className="text-[12px] font-medium text-uae-leaf hover:underline" data-id="element-642" data-mp="3woczgt5nu4y">
          Open outreach
        </Link>} data-id="element-641" data-mp="mfh43bg0uz7q">
      <ul className="space-y-3" data-id="element-643" data-mp="7z1h60s97jzm">
        {rows.map(({
        campaign,
        guarantee,
        percent
      }) => <li key={campaign.id} data-id="element-644" data-mp="cwbh4ad9re1p">
            <div className="flex items-baseline justify-between gap-3" data-id="element-645" data-mp="czfr5odf140a">
              <span className="min-w-0 truncate text-[12px] font-medium" data-id="element-646" data-mp="hx8xchepxy0k">
                {campaign.eventName}
              </span>
              <span className="shrink-0 font-mono text-[11px] text-muted-foreground" data-id="element-647" data-mp="mtptnyw2nioq">
                <span className="uppercase" data-id="element-648" data-mp="qvazj0a6uwpf">{campaign.tier}</span> ·{' '}
                {formatCompact(campaign.impressions)} / {formatCompact(guarantee)}
              </span>
            </div>
            <div className="mt-1 flex items-center gap-2" data-id="element-649" data-mp="10m5owdiqecf3">
              <div className="h-2 flex-1 overflow-hidden rounded-sm bg-muted" data-id="element-650" data-mp="15mtfwz6ymt9b">
                <div className="h-full rounded-sm" style={{
              width: `${Math.min(percent, 100)}%`,
              background: percent >= 70 ? 'var(--chart-1)' : 'var(--chart-3)'
            }} data-id="element-651" data-mp="1akv7y9md62wx" />
              </div>
              <span className={`w-10 text-right font-mono text-[11px] ${percent < 50 ? 'text-uae-bronze' : ''}`} data-id="element-652" data-mp="umispgyx3f83">
                {percent}%
              </span>
            </div>
          </li>)}
      </ul>
    </SectionCard>;
}